"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function MathJax(_ref) {
  var text = _ref.text,
    scale = _ref.scale,
    _ref$displayBlock = _ref.displayBlock,
    displayBlock = _ref$displayBlock === void 0 ? false : _ref$displayBlock;
  var rootElementRef = (0, _react.useRef)(null);
  // Store this in local state so we can make the component re-render when
  // it's updated.
  var _useState = (0, _react.useState)(window.__MathJax_State__.isReady),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isReady = _useState2[0],
    setIsReady = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    // Avoid running this script if the MathJax library hasn't loaded yet.
    if (!isReady) {
      // But trigger a re-render of this component once it is loaded.
      window.__MathJax_State__.promise.then(function () {
        return setIsReady(true);
      });
      return;
    }

    // This element won't be null at this point.
    var mathElement = rootElementRef.current;

    // Remove previous typeset children.
    mathElement.innerHTML = "";

    // Reset equation numbers.
    window.MathJax.texReset();

    // Construct options.
    var options = window.MathJax.getMetricsFor(mathElement);
    options.display = displayBlock;
    options.scale = scale !== null && scale !== void 0 ? scale : 1.1;
    window.MathJax.tex2chtmlPromise(text, options).then(function (node) {
      // `mathElement.replaceWith(node)` would be nicer markup-wise, but that
      // seems to mess with React's diffing logic.
      mathElement.appendChild(node);
      // Update the global MathJax CSS to account for this new element.
      window.MathJax.startup.document.clear();
      window.MathJax.startup.document.updateDocument();
    }).catch(function (err) {
      console.error(err);
    });
  }, [text, displayBlock, isReady]);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "mathjax-wrapper",
    ref: rootElementRef
  });
}
var _default = MathJax;
exports.default = _default;